import React from "react";

import BoxEmpty from "../assets/box_empty.svg";
import BoxFull from "../assets/box_full.svg";
import BoxQuarter from "../assets/box_one.svg";
import BoxThreeQuarters from "../assets/box_three.svg";
import BoxHalf from "../assets/box_two.svg";
import { FULL, HALF, QUARTER, THREE_QUARTER } from "../constants/constants";
interface BoxSkillRepresentationProps {
	size?: number;
	representationLevel?: number | string;
}

function BoxSkillRepresentation({
	size= 20,
	representationLevel,
}: BoxSkillRepresentationProps) {

	const ob = {
		width: `${size}px`,
		height: `${size}px`,
	};

	let src;
	let alt = "empty";
	switch (representationLevel) {
		case 1:
		case QUARTER:
			src = BoxQuarter;
			alt = "quarter";
			break;
		case 2:
		case HALF:
			src = BoxHalf;
			alt = "half";
			break;
		case 3:
		case THREE_QUARTER:
			src = BoxThreeQuarters;
			alt = "three-quarter";
			break;
		case 4:
		case FULL:
			src = BoxFull;
			alt = "full";
			break;
		default:
			src = BoxEmpty;
			alt = "empty";
			break;
	}

	return <img style={{ ...ob }} src={src} alt={alt} />;
}

export default BoxSkillRepresentation;
